export class RoleModel {
  roleId?: number;
  roleName?: string = '';
  roleDesc?: string = '';
}
